import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { getUserRole } from "../utils/authUtils";
import { DEMO_COMPANIES_DATA } from "../data/demoData";

interface DemoContextType {
  isDemoMode: boolean;
  companiesDocId: string;
}

const DemoContext = createContext<DemoContextType>({
  isDemoMode: false,
  companiesDocId: "companies",
});

const DEMO_DATA_VERSION = 4;

async function initializeDemoData() {
  try {
    const demoRef = doc(db, "prospects", "demoCompanies");
    const snap = await getDoc(demoRef);
    if (!snap.exists() || snap.data()?._demoVersion !== DEMO_DATA_VERSION) {
      await setDoc(demoRef, { ...DEMO_COMPANIES_DATA, _demoVersion: DEMO_DATA_VERSION });
      console.log("✅ Données démo initialisées (v" + DEMO_DATA_VERSION + ")");
    }
  } catch (err) {
    console.error("❌ Erreur initializeDemoData:", err);
  }
}

export const DemoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDemoMode, setIsDemoMode] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user?.email) {
        const role = await getUserRole(user.email);
        const isDemo = role === "demo";
        setIsDemoMode(isDemo);
        if (isDemo) {
          await initializeDemoData();
        }
      } else {
        setIsDemoMode(false);
      }
    });
    return () => unsubscribe();
  }, []);

  const companiesDocId = isDemoMode ? "demoCompanies" : "companies";

  return (
    <DemoContext.Provider value={{ isDemoMode, companiesDocId }}>
      {children}
    </DemoContext.Provider>
  );
};

export const useDemoContext = () => useContext(DemoContext);
